<template><!-- 上方步驟功能 -->
    <div id="step">
            <ul>
                <li v-for="(step,index) in stepAction" :key="index">
                    <div class="number" :class="{'active' : step.active , 'finish' : step.finish}">{{step.number}}</div>
                    <p>{{ step.stepName }}</p>
                </li>
            </ul>
    </div>
</template>
<script setup>
        import {onMounted, reactive} from "vue";

        const props = defineProps({
    stepNumber:Number
})

        const stepAction = reactive([
            {
                number:1,
                stepName:"保費試算",
                active:false,
                finish:false,
            },
            {
                number:2,
                stepName:"填寫資料",
                active:false,
                finish:false,
            },
            {
                number:3,
                stepName:"告知事項",
                active:false,
                finish:false,
            },
            {
                number:4,
                stepName:"確認資料",
                active:false,
                finish:false,
            },
            {
                number:5,
                stepName:"投保繳費",
                active:false,
                finish:false,
            },
            {
                number:6,
                stepName:"完成投保",
                active:false,
                finish:false,
            },
        ])
        const activeNumbers = ()=>{
            stepAction.forEach(steps =>{
                if(steps.number < props.stepNumber){
                    steps.active = false;
                    steps.finish = true;
                }
                if(steps.number === props.stepNumber){
                    steps.active = true;
                    steps.finish = false;
                }
                if(steps.number > props.stepNumber){
                    steps.active = false;
                    steps.finish = false;
                }
            })
        }

        onMounted(()=>{
            activeNumbers();
        })
</script>

<style lang="scss">
#step{
    padding-top:100px;
    width:600px;
    margin:0 auto;
    position:relative;
    @media screen and (max-width: $small) {
        width:100%;
        margin:20px auto;
        padding-top:80px;
    }
    &::after{
        content: "";
        display: block;
        background: $btnGray;
        height:2px;
        position: absolute;
        bottom: 60px;
        z-index: 100;
        left: 50%;
        margin-left: -260px;
        width: calc(100% - 80px);
        @media screen and (max-width: $small) {
            width: 89%;
            bottom: 15%;
            left: 50%;
            margin-left: -45%;
        }
    }
    ul{
        display: flex;
        position:relative;
        z-index: 200;
            li{
                width:16.5%;
                .number{
                width:40px;
                height:40px;
                border-radius: 40px;
                text-align: center;
                color:$textColor;
                border:3px solid $btnGray;
                margin:0 30px;
                line-height:33px;
                font-size:22px;
                font-weight:bold;
                box-sizing: border-box;
                background:#fff;
                @media screen and (max-width: $small) {margin:0 auto;}
                 &.active{
                    border:3px solid $yellow;
                    &+p{
                        color: #4F4F4F;
                    }
                 }
                 &.finish{
                    border:3px solid $yellow;
                    background:$yellow;
                    text-indent: -9999px;
                    background-image: url(../assets/finish.svg);
                    background-repeat: no-repeat;
                    background-position: center;
                 }
                }
                p{
                color:$btnGray; 
                text-align: center;
                margin:10px 0;
                @media screen and (max-width: $small) {display: none;}
                }
            }
    }
}


</style>